module.exports = __webpack_public_path__ + "static/media/Basal_4651.0aabe139.jpg";